<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;
      try {
        const channel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'uazapi_whatsapp',
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { inbox_id: channel.id },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="mb-6">
      <h2 class="text-lg font-medium text-n-slate-12 mb-2">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.TITLE') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.DESCRIPTION') }}
      </p>
    </div>

    <div class="flex flex-col gap-4">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="p-4 mt-4 rounded-lg bg-n-alpha-1 border border-n-weak">
      <div class="flex items-start gap-3">
        <div
          class="flex items-center justify-center w-8 h-8 rounded-full bg-n-blue-2 text-n-blue-11"
        >
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </div>
        <div>
          <h3 class="text-sm font-medium text-n-slate-12 mb-1">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.NEXT_STEPS.TITLE') }}
          </h3>
          <ul class="text-sm text-n-slate-11 space-y-1">
            <li>
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.NEXT_STEPS.STEP_1') }}
            </li>
            <li>
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.NEXT_STEPS.STEP_2') }}
            </li>
            <li>
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.NEXT_STEPS.STEP_3') }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="w-full mt-6">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
